export const materialIcons = 'material-icons';
export const materialSymbolsOutlined = 'material-symbols-outlined';
export const NEW = 'new';
